import React from 'react';
import { ArrayField, Datagrid, TextField, useRecordContext } from 'react-admin';

import { EducationCenterType } from 'src/components/Employees/types';

const DepartmentsInfoTab: React.FC = () => {
    const records = useRecordContext<EducationCenterType>();

    if (!records) return null;

    return (
        <ArrayField source="hospitalDepartments">
            <Datagrid bulkActionButtons={false}>
                <TextField label="Назва відділеня" source="departmentName" />
            </Datagrid>
        </ArrayField>
    );
};

export default DepartmentsInfoTab;
